export function parseFinite(value: string | number | null | undefined): number | undefined {
  if (value == null) return undefined
  const num = typeof value === 'number' ? value : parseFloat(value)
  return Number.isFinite(num) ? num : undefined
}

export function parseIntFinite(value: string | number | null | undefined): number | undefined {
  const num = parseFinite(value)
  if (num == null) return undefined
  return Math.trunc(num)
}

export function isNumber(value: unknown): value is number {
  return value != null && typeof value === 'number' && isFinite(value)
}

export function formatNumber(value: number, precision?: number): string
export function formatNumber(value: number | null | undefined, precision?: number): string | undefined
export function formatNumber(value: number | null | undefined, precision = 2): string | undefined {
  if (!isNumber(value)) return undefined
  const format = Intl.NumberFormat('en', { useGrouping: true, maximumFractionDigits: precision })
  return format.format(value).replaceAll(',', ' ')
}

export function formatPercent(value: number): string {
  const format = Intl.NumberFormat('en', { maximumFractionDigits: 2 })
  return format.format(value) + '%'
}
